var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-alma',
                        view: publicPath + 'sprite.svg#view-icon-alma',
                        viewBox: '0 0 22 12',
                        title: 'Alma-Logo',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };